export function closeGetPostsFetch() {
    return {
        type: 'API_GET_POSTS_CLOSE_FETCH',
    }
}

export function closeCreatePostFetch() {
    return {
        type: 'API_CREATE_POST_CLOSE_FETCH',
    }
}

export function closeUpdatePostFetch() {
    return {
        type: 'API_UPDATE_POST_CLOSE_FETCH',
    }
}

export function getPosts(taskId) {
    return {
        type: 'API_GET_POSTS',
        payload: {
            request: {
                method: 'GET',
                url: `/tasks/${taskId}/posts`
            }
        }
    }
}

export function createPost(post, taskId) {
    return {
        type: 'API_CREATE_POST',
        payload: {
            request: {
                method: 'POST',
                url: `/tasks/${taskId}/posts`,
                data: post,
            }
        }
    }
}

export function addPost(post) {
    return {
        type: 'ADD_POST',
        payload: {
            post: post,
        }
    }
}

export function updatePost(post) {
    return {
        type: 'API_UPDATE_POST',
        payload: {
            request: {
                method: 'PUT',
                url: `/posts/${post.id}`,
                data: post,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/posts.js